import coreService from '@/services/core'
import rewardService from '@/services/reward'
// import moment from 'moment-timezone'
import router from '@/router'

export default {
    namespaced: true,
    state: {
        reward_item:[],
        panelData:[],
        rewardData : {},
        rewards: [],
        editPanelData: [],
        campaignData : [],
        claimData : []
    },
    getters: {
        reward_item: state => {
            return state.reward_item;
        },
        rewards : state => {
            return state.rewards;
        },
        campaignData: state => {
            return state.campaignData;
        },
        claimData : state => {
            return state.claimData
        }
    },
    mutations: {
        setReward(state, value) {
            state.reward_item = value;
        },
        setPanelData(state, value){
            state.panelData = value;
        },
        setRewardData(state, value){
            state.rewardData = value;
        },
        clearRewardData(state){
            state.rewardData = {};
        },
        setRewards(state, value){
            state.rewards = value;
        },
        setEditPanelData(state, value){
            state.editPanelData = value;
        },
        setCampaignData(state, value){
            state.campaignData = value;
        },
        setClaimData(state, value){
            state.claimData = value
        }
    },    
    actions: {
        getReward({commit, state}){
            rewardService.getAllReward()
            .then((response) => {
              commit('setRewards',response)
            })
            .catch((error) => console.log(error))   
        },
        getCampaignData({commit, state}){
            rewardService.getCampaignData()
            .then((response) => {
              commit('setCampaignData',response)
            })
            .catch((error) => console.log(error))   
        },
        setPanelData({commit, state}, data){
            commit('setPanelData', data)
        },
        setRewardData({commit, state}, data){
            commit('setRewardData', data)
        },
        insertRewardData( { commit, state, dispatch }, data) {
            rewardService.createReward(data)
              .then(() => {
                commit('clearRewardData')
                dispatch("getReward")
                // router.replace('/campaign/manage')
              })
              .catch((error) => console.log(error))
        },
        updateRewardData( { commit, state, dispatch }, data) {
            rewardService.updateReward(data)
              .then((response) => {
                commit('clearRewardData')
                rewardService.getAllReward()
                .then((response) => {
                    commit('setRewards',response)
                })
                .catch((error) => console.log(error)) 
                // router.replace('/campaign/manage')
              })
              .catch((error) => console.log(error))
        },
        setEditPanelData({commit, state}, data){
            commit('setEditPanelData', data)
        },
        getClaimData( { commit, state }) {
            rewardService.getClaimData()
              .then((response) => {
                commit('setClaimData',response)
                // router.replace('/campaign/manage')
              })
              .catch((error) => console.log(error))
        }
    }

}